import * as TypeGraphQL from "type-graphql";
export var ABTestStatus;
(function (ABTestStatus) {
    ABTestStatus["DRAFT"] = "DRAFT";
    ABTestStatus["RUNNING"] = "RUNNING";
    ABTestStatus["COMPLETED"] = "COMPLETED";
    ABTestStatus["CANCELLED"] = "CANCELLED";
})(ABTestStatus || (ABTestStatus = {}));
TypeGraphQL.registerEnumType(ABTestStatus, {
    name: "ABTestStatus",
    description: undefined,
});
//# sourceMappingURL=ABTestStatus.js.map